module.exports = __webpack_public_path__ + "static/media/coinzoom-420x78.f6795948.png";